import React from 'react';

const Feature = (props) => {
    return (
        
        <>
        {/*feature-style-two */}
        <section className="feature-style-two pt_50 pb_50">
                <div className="auto-container">
                    <div className="row clearfix">
                        <div className="col-lg-4 col-md-6 col-sm-12 feature-block">
                            <div className="feature-block-two">
                                <div className="inner-box">
                                    <div className="icon-box"><i className="icon-12"></i></div>
                                    <h3>Expert Team</h3>
                                    <p>Amet minim mollit no duis sit enim aliqua dolor do amet officia.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 feature-block">
                            <div className="feature-block-two">
                                <div className="inner-box">
                                    <div className="icon-box"><i className="icon-11"></i></div>
                                    <h3>Modern Machines</h3>
                                    <p>Amet minim mollit no duis sit enim aliqua dolor do amet officia.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 feature-block">
                            <div className="feature-block-two">
                                <div className="inner-box">
                                    <div className="icon-box"><i className="icon-13"></i></div>
                                    <h3>Affordable Pricing</h3>
                                    <p>Amet minim mollit no duis sit enim aliqua dolor do amet officia.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/*feature-style-two end */}
        </>


    );
}

export default Feature;
